import React from 'react';

import Colors from 'common/colors/constants';
import Button from 'common/inputs/Button';
import ModernModal from 'common/modals/ModernModal';

import 'css/components/modals/_DeleteModal.scss';

type Props = {
  onClose(): void;
  onConfirm(): void;
  title?: string;
  type: 'comment' | 'post';
};

const MaxCharLimit = 64;
const RedBackground = Colors.red90;
const TypeTextValues = {
  comment: {
    cta: 'Delete comment',
    header: 'Delete comment',
    information: 'Please confirm that you would like to delete the comment.',
  },
  post: {
    cta: 'Delete post',
    header: 'Delete post',
    information:
      'Please confirm that you would like to delete the post and all subsequent activity.',
  },
};

const DeleteModal = ({ onClose, onConfirm, title, type }: Props) => {
  const titleContainer = title
    ? title.length > MaxCharLimit
      ? `"${title.slice(0, MaxCharLimit).trim()}..."`
      : `"${title}"`
    : `this ${type}`;
  const { cta, header, information } = TypeTextValues[type];

  return (
    <ModernModal
      overlayClassName="deleteModalPortal"
      onClose={onClose}
      header={header}
      sections={[
        <>
          <div>
            <p className="title">Are you sure you'd like to delete {titleContainer}?</p>
            <p className="information">{information}</p>
            <p className="warning">This action is irreversible.</p>
          </div>
        </>,
      ]}
      footer={
        <>
          <Button buttonType="ghostButton" onTap={onClose} value="Cancel" />
          <Button
            buttonStyle={{ background: RedBackground }}
            buttonType="cannyButton"
            onTap={onConfirm}
            value={cta}
          />
        </>
      }
    />
  );
};

export default DeleteModal;
